import "./teamBodyResults.sass";

/**
 * Componente unificado para mostrar información de equipos
 * Maneja tanto equipo izquierdo como derecho con orden diferente de elementos
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.image - URL de la imagen del equipo
 * @param {string} props.name - Nombre del equipo
 * @param {string} props.position - Posición del equipo ('left' o 'right')
 * @param {string} props.right_image - URL imagen derecha (retrocompatibilidad)
 * @param {string} props.right_name - Nombre derecha (retrocompatibilidad)
 * @param {string} props.left_image - URL imagen izquierda (retrocompatibilidad)
 * @param {string} props.left_name - Nombre izquierda (retrocompatibilidad)
 * 
 * @returns {JSX.Element} Sección del equipo con imagen y nombre
 */
export default function TeamBodyResults({  
  position = 'right',
  right_image,
  right_name,
  left_image,
  left_name
}) {
  // Retrocompatibilidad con props anteriores
  const teamImage = right_image || left_image;
  const teamName = right_name || left_name;
  const teamPosition = position === 'left' || left_image || left_name ? 'left' : 'right';
  
  const isLeft = teamPosition === 'left';
  const sectionClass = `results_bodySection results__body-${teamPosition}`;

  return (
    <div className={sectionClass}>
      {isLeft ? (
        <>
          <span className="team-name">{teamName}</span>
          <img src={teamImage} alt={teamName} className="team-logo" loading="lazy" />
        </>
      ) : (
        <>
          <img src={teamImage} alt={teamName} className="team-logo" loading="lazy" />
          <span className="team-name">{teamName}</span>
        </>
      )}
    </div>
  );
}